var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isHasDisease)?_c('AppointmentFormCP',{attrs:{"disease":_vm.disease,"personData":_vm.personData},on:{"nextStep":_vm.nextStep}}):_c('AppointmentFormNCP',{attrs:{"personData":_vm.personData},on:{"nextStep":_vm.nextStep}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }